const initialState = {
    reactBaseUrl: "http://192.168.1.52:3000/",
    geoserverUrl: "http://192.168.1.52:8080/geoserver/"
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        default: return state;
    }
};

export default reducer;